module.exports = __webpack_public_path__ + "static/media/add off game.e4df4d04.svg";